import { declareParams } from '@farfetched/core';
import { zodContract } from '@farfetched/zod';
import { createAuthMutation } from '../auth-http-client';
import { cashdeskTransactionSchema } from '../types';

export type WithdrawPlayerMutationParams = {
	id: number;
	amount: number;
};

export const createWithdrawPlayerMutation = () =>
	createAuthMutation({
		params: declareParams<WithdrawPlayerMutationParams>(),
		request: {
			method: 'POST',
			url: (params) => `/device/withdraw/${params.id}`,
			body: (data) => ({
				amount: data.amount,
			}),
		},
		response: {
			contract: zodContract(cashdeskTransactionSchema),
		},
	});
